export const appsSectionDataHooks = {
  container: 'apps-section-container',
  title: 'section-title',
  button: 'see-all-apps-button',
};
